import { ProductListConfig } from "./ProductList.config";

export const adminCategoriesTableConfig: ProductListConfig = {
  columns: [
    { key: "index", label: "S.NO", align: "center" },
    { key: "name", label: "Name", align: "left" },
    { key: "icon", label: "Icon", align: "center" },
    { key: "banner", label: "Banner", align: "center" },
    { key: "coverImage", label: "Cover", align: "center" },
    { key: "parent", label: "Parent", align: "left" },
    { key: "sortOrder", label: "Sort", align: "center" },
    { key: "level", label: "Level", align: "center" },
    { key: "productCount", label: "Products", align: "center" },
    { key: "isActive", label: "Active", align: "center" },
    { key: "featured", label: "Featured", align: "center" },
    { key: "actions", label: "Actions", align: "center" },
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
    statusStyles: {
      active: { background: "bg-green-100", textColor: "text-green-700" },
      inactive: { background: "bg-red-100", textColor: "text-red-700" },
      featured: { background: "bg-yellow-100", textColor: "text-yellow-700" },
    },
  },
};
